import React from 'react';
import { StyledInput } from './styled';
import PropTypes from 'prop-types';

const Input = React.memo(
  ({
    placeholder,
    allowClear = true,
    onPressEnter,
    borderRadius,
    widthInput,
    heightInput,
    border,
    value,
    onChange,
    ...rest
  }) => {
    return (
      <StyledInput
        placeholder={placeholder}
        $allowClear={allowClear}
        borderRadius={borderRadius}
        value={value}
        onChange={onChange}
        $widthInput={widthInput}
        $heightInput={heightInput}
        $border={border}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && onPressEnter) {
            onPressEnter(e);
          }
        }}
        {...rest}
      />
    );
  }
);

Input.propTypes = {
  placeholder: PropTypes.string,
  allowClear: PropTypes.bool,
  onPressEnter: PropTypes.func,
  fontSize: PropTypes.string,
  borderRadius: PropTypes.string,
  padding: PropTypes.string,
  border: PropTypes.string,
  bgColor: PropTypes.string,
  color: PropTypes.string,
  borderColor: PropTypes.string,
  placeholderColor: PropTypes.string,
};

Input.displayName = 'Input';

export default Input;
